<template>
    <div id="rule">
        <div class="container">
            <p>活动规则</p>
            <span>分享活动页面至微信群或朋友圈，即可与好友一起领取有道词典VIP会员</span>
            <span>每人可免费领取1个月VIP；6位好友通过你分享的页面成功领取VIP，你将可领取6个月VIP</span>
            <span>6个月VIP可以与1个月VIP叠加兑换，兑换第二个VIP码时需待上一VIP时限过期</span>
            <span>VIP码即日起至2019.06.30有效，请在有效期内兑换</span>
            <span>兑换路径：打开“有道词典”登录-我的-会员中心-兑换会员-输入VIP兑换码</span>
        </div>
        <p>Jirin 21 / Shin-Jirin, Japanese-Chinese EditionCopyright © 1993, 1999<br> by SANSEIDO CO., LTD.& Foreign Language Teaching and Research Publishing Co.,Ltd.</p>
    </div>
</template>

<script>
    export default {
        name: 'app'
    }
</script>

<style>
    #rule {
        overflow: hidden;
        margin: 0 auto 0.86rem;
    }
    #rule .container {
        margin: 0 auto;
        width: 6.46rem;
        padding: 1.14rem 0.16rem 0.96rem;
        box-sizing: border-box;
        overflow: hidden;
        background-image: url(http://shared.youdao.com/dict/market/oxford-activity/imgs/rulebg.png);
        background-size: 100% 100%;
    }
    
    #rule p {
        width: 100%;
        text-align: center;
        font-size: 0.38rem;
        color: #3f3f3f;
        line-height: 0.4rem;
        margin-bottom: 0.6rem;
    }
    #rule > p {
        display: block;
        font-size: 0.12rem;
        line-height: 0.18rem;
        color: #818181;
        margin-top: 0.3rem;
    }
    #rule span {
        display: block;
        position: relative;
        padding-left: 10px;
        font-size: 0.3rem;
        line-height: 0.36rem;
        margin-bottom: 0.4rem;
        color: #3f3f3f;
    }
    #rule span:last-child {
        margin-bottom: 0;
    }
    #rule span::before {
        content: "-";
        color: #3f3f3f;
        position: absolute;
        left: 0;
        font-size: 0.36rem;
    }
</style>



// WEBPACK FOOTER //
// Rule.vue?a3e32594